import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import * as moment from 'moment';
import { AppointmentStatus } from 'projects/app-core/src/app/session/models/TherapistAppointment';
import { TherapyPlansSubscriptionSessionDetails } from '../../models/therapyPlansSubcriptionGridResponse';

interface SelectableSession {
  sessionId: string;
  label: string;
  checked: boolean;
}

/**
 * Lists the completed sessions of a plan or pack, taken from the subscription
 * grid's session details, with a checkbox each.
 */
@Component({
  selector: 'app-session-feedback-selector',
  standalone: true,
  imports: [CommonModule, FormsModule, NzCheckboxModule],
  templateUrl: './session-feedback-selector.component.html',
})
export class SessionFeedbackSelectorComponent implements OnChanges {
  @Input() sessions: TherapyPlansSubscriptionSessionDetails[] = [];
  @Input() title = 'Send a feedback document mail to the therapist';
  @Output() selectedSessionIdsChange = new EventEmitter<string[]>();

  completedSessions: SelectableSession[] = [];
  allChecked = false;
  indeterminate = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['sessions']) {
      this.completedSessions = (this.sessions || [])
        .filter(
          (s) => s.sessionStatus === AppointmentStatus.COMPLETED && s.sessionId,
        )
        .map((s) => ({
          sessionId: s.sessionId!,
          label: `${s.sessionName || 'Session'} · ${
            s.sessionDate
              ? moment(s.sessionDate).format('DD MMM YYYY, hh:mm A')
              : 'N/A'
          } · ${s.therapistName || 'N/A'}`,
          checked: false,
        }));
      this.emitSelection();
    }
  }

  onAllCheckedChange(checked: boolean) {
    this.completedSessions.forEach((s) => (s.checked = checked));
    this.emitSelection();
  }

  onSessionCheckedChange() {
    this.emitSelection();
  }

  private emitSelection() {
    const selected = this.completedSessions.filter((s) => s.checked);
    this.allChecked =
      selected.length > 0 && selected.length === this.completedSessions.length;
    this.indeterminate = selected.length > 0 && !this.allChecked;
    this.selectedSessionIdsChange.emit(selected.map((s) => s.sessionId));
  }
}
